import React from 'react';
import { RegisterLoginForm } from 'cccisd-laravel-nexus';
import style from './style.css';

export default class RegisterPage extends React.Component {
    registerProps = {
        title: 'Register',
        role: 'learner',
        showPasswordFields: true,
        isRecaptchaRequired: true,
    };

    loginProps = {
        title: 'Log In',
        showPasswordToggle: true,
    };

    render() {
        return (
            <div className={style.registerPage}>
                <RegisterLoginForm registerProps={this.registerProps} loginProps={this.loginProps} />
            </div>
        );
    }
}
